<div class="settings-item">
  <p
    #title
    class="settings-item__title"
    [matTooltipDisabled]="title.offsetWidth >= title.scrollWidth"
    matTooltip="{{ getTitle() }}"
  >
    {{ getTitle() }}
  </p>
  <p class="settings-item__subtitle">{{ invitation.inviteeEmail }}</p>
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-row gap-[4px]">
      <ng-container
        *ngFor="let pill of invitation.accessLevel | partnerAccessPills: invitation.status"
      >
        <app-pill [type]="pill.type">{{ pill.text }}</app-pill>
      </ng-container>
    </div>
    <ng-container *ngIf="authStore.isUserOfCommercialOwnerCompanyWithRoleInvitation$ | async">
      <mat-icon
        *ngIf="
          invitation.status === InvitationStatusType.Pending ||
          invitation.status === InvitationStatusType.Accepted
        "
        (click)="deleteInvitation.emit()"
        >delete</mat-icon
      >
      <mat-icon
        *ngIf="
          invitation.status === InvitationStatusType.Rejected ||
          invitation.status === InvitationStatusType.Expired
        "
        (click)="hideInvitation.emit()"
        >delete</mat-icon
      >
    </ng-container>
  </div>
</div>
